import { Fragment } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Route } from 'react-router-dom';
import { setPositionFixed } from 'helpers';
import NavList from 'components/NavList';
import SwitchWithRedirect from 'components/SwitchWithRedirect';

import { AboutSiteplus, OurValues, OurLifestyle } from './components';

const LINKS = [
  {
    link: '',
    text: 'About Siteplus',
  },
  {
    link: '/our-values',
    text: 'Our values',
  },
  {
    link: '/our-lifestyle',
    text: 'Our lifestyle',
  },
];

const AboutUs = ({ location }) => (
  <Fragment>
    <section className="section section_about_1">
      <div className="wrapper">
        <div className="row">
          <div className="col col-12">
            <h1 className="title section__title">
              <span className="title__break">A world leading</span> Website
              Builder platform
            </h1>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_about_2">
      <NavList tabs={LINKS} root="about-us" listClassName="tab-menu_about-us" />
      <TransitionGroup>
        <CSSTransition
          key={location.key}
          classNames="fade"
          timeout={300}
          onExit={setPositionFixed}
        >
          <div className="section__articles route-section">
            <SwitchWithRedirect location={location}>
              <Route path="/about-us" component={AboutSiteplus} exact />
              <Route path="/about-us/our-values" component={OurValues} />
              <Route path="/about-us/our-lifestyle" component={OurLifestyle} />
            </SwitchWithRedirect>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </section>
  </Fragment>
);

export default AboutUs;
